module.exports = __webpack_public_path__ + "static/media/send.7e2fc43c.svg";